import { render, staticRenderFns } from "./roleAssignedTo.vue?vue&type=template&id=a91f2ce8&scoped=true"
import script from "./roleAssignedTo.vue?vue&type=script&lang=js"
export * from "./roleAssignedTo.vue?vue&type=script&lang=js"
import style0 from "./roleAssignedTo.vue?vue&type=style&index=0&id=a91f2ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91f2ce8",
  null
  
)

export default component.exports